import { BaseExportStrategy } from "./BaseExportStrategy";
import { IExportStrategyConfig } from "./types";

export class MerchantExportStrategy extends BaseExportStrategy {
  getConfig(): IExportStrategyConfig {
    return {
      carriersEndpoint: `carriers_merchants?marketplaceId=${this.marketplaceId}&getAll=true`,
      ordersEndpoint: "orders",
      filesEndpoint: "/orders/files",
      summaryEndpoint: "/orders/summary",
      needsMerchants: false,
      needsAliases: true,
      needsMarketplaceId: true,
      needsClients: false,
    };
  }
}
